import React from 'react';
import HiddenLoader from '../components/Loader/HiddenLoader';

const HiddenLoading = () => <HiddenLoader />;

export default HiddenLoading;
